// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202604281244/js/" + chunkId + "." + {"44":"a6e4a273","225":"0b6be72a","481":"b024ab5a","486":"027efc81","770":"f50809f4"}[chunkId] + ".0.18019870568002028.chunk.js";
};